import React from 'react';
import RataDeNegro from './assets/RataDeNegro.png';

class ErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false };
  }

  static getDerivedStateFromError() {
    return { hasError: true };
  }

  componentDidCatch(error, info) {
    // Podrías reportar el error a un servicio aquí
    // console.error('ErrorBoundary captured:', error, info);
  }

  render() {
    if (this.state.hasError) {
      return (
        <div className="app-error-fallback">
          <h2>Ocurrió un error inesperado</h2>
          <p>Por favor, recarga la página. Si el problema persiste, contáctanos.</p>
          <img src={RataDeNegro} alt="Ratafit sorpresa" />
          <p>Acutliza y olvida lo que viste.</p>
          <button onClick={() => window.location.reload()}>Recargar</button>
        </div>
      );
    }
    return this.props.children;
  }
}

export default ErrorBoundary;


